import React, { useState, useEffect } from 'react';
import { useLanguage } from '@/i18n/LanguageContext';
import { Cookie } from 'lucide-react';

const CookieBanner = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up"
      role="dialog"
      aria-label="Cookie notice"
    >
      <div className="max-w-4xl mx-auto bg-[#111113] border border-[#1f1f23] rounded-2xl p-4 sm:p-5 shadow-2xl shadow-black/50">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Icon */}
          <div className="hidden sm:flex w-10 h-10 rounded-xl bg-[#2ec4aa]/10 items-center justify-center flex-shrink-0">
            <Cookie size={20} className="text-[#2ec4aa]" aria-hidden="true" />
          </div>
          
          {/* Text */}
          <p className="text-gray-300 text-sm leading-relaxed flex-1">
            {t.legal?.cookieNotice || 'This website uses cookies to ensure proper functionality and improve user experience. By continuing to use the site, you agree to the use of cookies.'}
          </p>
          
          {/* Button */}
          <button
            onClick={handleAccept}
            className="w-full sm:w-auto px-6 py-2.5 bg-[#2ec4aa] text-black font-semibold rounded-full hover:bg-[#3ed4ba] transition-all text-sm flex-shrink-0"
            data-testid="cookie-accept-btn"
          >
            {t.legal?.cookieAccept || 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
